@use 'styles/variables' as *;

.authenticatedLayout {
  --layout-header: var(--layout-header-height);
  --layout-footer: var(--layout-footer-height);
  --layout-padding: var(--default-padding);
  --layout-list-bottom-padding: var(--spacing-32);
  --layout-small-margin: var(--spacing-8);
  --layout-medium-margin: var(--spacing-16);
  --layout-large-margin: var(--spacing-24);
  --layout-extra-large-margin: var(--spacing-32);
  --layout-intra-divisional-margin: var(--spacing-12);
  --layout-inline-margin: var(--spacing-8);
  --layout-sheet-radius: var(--border-radius-sheet);

  position: relative; /* in order for the child elements to attach to the layout */
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background-color: transparent; /* should be transparent for desktop view and map layout view */
  margin: auto; /* in order for layout to be positioned on the center of the page */
  overflow: hidden; /* the main sizing of the layout fits the viewport exactly, layout children are responsible for handling their own overflow behavior */

  // items center alignment 
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  > header {
    // default positioning
    position: absolute;
    top: 0;
    z-index: var(--z-index-header);
    margin: auto;
    // header max width is handled internally
    & ~ main {
      // todo: [LAYOUT] may need extra padding and margin between main and header
      padding-top: var(--layout-header);
    }
  }

  > main {
    // default positioning
    position: relative;
    z-index: 0;
    overflow: auto;
    max-width: var(--max-width);
  }

  > footer {
    // default positioning
    position: absolute;
    bottom: 0;
    z-index: var(--z-index-header);
    margin: auto;
    // footer max width is handled internally
    // footer height is auto and should be calculated to be added as a margin to the main component
  }
}
